import React from "react";
import styles from "../../pages/styles";
import {
  facebook,
  instagram,
  logowithclouds,
} from "../../assets/images/index.js";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <div className="bg-darkprimary xl:rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10 text-center md:text-left">
          
          {/* Logo & Social */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <a href="/">
              <img src={logowithclouds} className="w-40" alt="Tech Tails Logo" />
            </a>
            <p className={`${styles.paragraphwhite} max-w-xs text-sm`}>
              Empowering the next generation of tech creators through personalized, engaging virtual classes.
            </p>
            <div className="flex gap-4 mt-2">
              <a 
                href="https://www.instagram.com/techtails.teaching" 
                className="w-10 h-10 bg-white/10 hover:bg-pinkprimary rounded-lg flex items-center justify-center transition-all hover:scale-110"
                aria-label="Instagram"
              >
                <img src={instagram} className="w-6 h-6" alt="Instagram" />
              </a>
              <a
                href="https://www.facebook.com/techtails.teaching"
                className="w-10 h-10 bg-white/10 hover:bg-pinkprimary rounded-lg flex items-center justify-center transition-all hover:scale-110"
                aria-label="Facebook"
              >
                <img src={facebook} className="w-6 h-6" alt="Facebook" />
          </a>
        </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-3">
            <h3 className={`${styles.paragraphwhite} font-bold mb-2 text-sm`}>Quick Links</h3>
            <a href="/" className={`${styles.paragraphwhite} text-sm hover:text-pinkprimary transition-colors`}>
              Home
            </a>
            <a href="/pages/privacypolicy" className={`${styles.paragraphwhite} text-sm hover:text-pinkprimary transition-colors`}>
            Privacy Policy
          </a>
            <a href="/pages/termsofservice" className={`${styles.paragraphwhite} text-sm hover:text-pinkprimary transition-colors`}>
            Terms of Service
          </a>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col gap-3">
            <h3 className={`${styles.paragraphwhite} font-bold mb-2 text-sm`}>Get In Touch</h3>
            <a 
              href="tel:8017047878" 
              className={`${styles.paragraphwhite} text-sm hover:text-pinkprimary transition-colors flex items-center gap-2 justify-center md:justify-start`}
            >
              <Phone size={16} className="text-orangeprimary" />
              (801) 704-7878
          </a>
          <a
            href="mailto:teacher@techtails.com"
              className={`${styles.paragraphwhite} text-sm hover:text-pinkprimary transition-colors flex items-center gap-2 justify-center md:justify-start`}
          >
              <Mail size={16} className="text-orangeprimary" />
              teacher@techtails.com
          </a>
            <div className={`${styles.paragraphwhite} text-sm flex items-start gap-2 justify-center md:justify-start`}>
              <MapPin size={16} className="text-orangeprimary flex-shrink-0 mt-1" />
              <span>1878 W 12600 S<br />Riverton, UT 84065</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <p className={`${styles.paragraphwhite} text-sm text-center text-white/70`}>
            © 2026 TechTails, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
